import { Headline3, Meta, theme } from 'aimo-ui';
import Icon from 'components/icons/Icon';
import { OngoingSessionsIcons } from 'components/ongoingParking/OngoingParkingComponents';
import {
  OngoingParkingHeaderStyles,
  OngoingParkingHeaderWrapper,
} from 'components/ongoingParking/styles';
import { Row } from 'components/park/styles/styles';
import useOngoingMultipleSession from 'hooks/useOngoingMultipleSession';
import { groupBy } from 'lodash';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';
import Animated, { FadeIn } from 'react-native-reanimated';
import { CenterRow } from 'styles/ContainerStyles';
import { OngoingSessionType } from 'types/common';
import { useUiStore } from 'stores/uiStore';

const OngoingMultipleSessionsHeader: React.FC = () => {
  const { t } = useTranslation();
  const { parkAndChargeData } = useOngoingMultipleSession();

  const sessionsGroupedByParkZone = useMemo(
    () =>
      groupBy(parkAndChargeData, (res) => {
        return res.parkZone?.uid;
      }),
    [parkAndChargeData]
  );

  return (
    <Animated.View entering={FadeIn.duration(200)}>
      <Pressable
        style={OngoingParkingHeaderStyles.container}
        onPress={() =>
          useUiStore.getState().setSheetModal('showOngoingMultipleSessions')
        }
        testID="ongoing-multiple-container">
        <OngoingParkingHeaderWrapper mr={20} grow>
          <Headline3 numberOfLines={1} color={theme.colors.white}>
            {t('parking.ongoingActiveServicesCount', {
              count:
                parkAndChargeData && parkAndChargeData.length > 1
                  ? parkAndChargeData.length
                  : 0,
            })}
          </Headline3>
          <Row>
            {Object.values(sessionsGroupedByParkZone).map(
              (sessionsByParkZone: OngoingSessionType[]) => (
                <CenterRow
                  key={`ongoing-session-header-${sessionsByParkZone[0].parkZone?.name}`}>
                  <OngoingSessionsIcons
                    sessionsByParkZone={sessionsByParkZone}
                  />
                  <Meta numberOfLines={1} color={theme.colors.white}>
                    {sessionsByParkZone[0].parkZone?.name}
                  </Meta>
                </CenterRow>
              )
            )}
          </Row>
        </OngoingParkingHeaderWrapper>
        <OngoingParkingHeaderWrapper>
          <Pressable
            onPress={() =>
              useUiStore.getState().setSheetModal('showOngoingMultipleSessions')
            }>
            <Icon
              name="Chevron_Right"
              size="m"
              testID="chevron-right"
              color={theme.colors.white}
            />
          </Pressable>
        </OngoingParkingHeaderWrapper>
      </Pressable>
    </Animated.View>
  );
};

export default OngoingMultipleSessionsHeader;
